import { $touchMode } from "../../state/touch";

/** Below this width an upright screen is a phone; a tablet held upright is wide enough to play. */
export const PHONE_WIDTH = 600;

export const isPortrait = (w: number, h: number): boolean => h > w && w < PHONE_WIDTH;

/** In touch mode a portrait phone gets a cover asking to turn it (spec 2p §2.6); the world keeps running underneath. */
export function mountPortrait(onTurn: () => void): void {
  const el = document.createElement("div");
  el.className = "portrait-block";
  el.textContent = "請把手機轉成橫向";
  document.body.appendChild(el); // above #ui, so it covers the panels too
  let shown = false;
  const sync = () => {
    const now = $touchMode.get() && isPortrait(window.innerWidth, window.innerHeight);
    if (now === shown) return;
    shown = now;
    el.classList.toggle("show", now);
    onTurn();
  };
  window.addEventListener("resize", sync);
  $touchMode.subscribe(sync);
}
